import React, { FC, ReactNode } from 'react';
import { trackEvent } from 'dibs-tracking';
import classnames from 'classnames';

import styles from './LinkColumnItem.scss';

type Props = {
    message: ReactNode;
    trackingLabel: string;
    href: string;
    target?: string;
    dataTn?: string;
    badgeText?: ReactNode;
    isLegalLink?: boolean;
};
const LinkColumnItem: FC<Props> = ({
    target,
    trackingLabel,
    href,
    dataTn,
    message,
    badgeText,
    isLegalLink,
}) => {
    const doNotShowPrivacyPolicyAlerts = true;
    const shouldShowBadge = !!badgeText && !doNotShowPrivacyPolicyAlerts;

    function trackClick(): void {
        const category = 'navigation';
        const action = 'footer navigation click';
        const label = trackingLabel.trim().toLowerCase();
        trackEvent({ category, action, label });
    }
    return (
        <li className={classnames(styles.item, { [styles.isLegalLink]: !!isLegalLink })}>
            {href ? (
                <a
                    className={styles.link}
                    target={target}
                    href={href}
                    onClick={trackClick}
                    data-tn={dataTn}
                    rel="noopener"
                >
                    {message}
                    {shouldShowBadge && <div>{badgeText}</div>}
                </a>
            ) : (
                message
            )}
        </li>
    );
};
export default LinkColumnItem;
